import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTA() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative bg-[#0d1a2e] text-white rounded-3xl px-8 py-14 lg:p-16 lg:px-20 overflow-hidden">
          <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />
          <div className="absolute -top-32 -right-32 w-[34rem] h-[34rem] glow-emerald pointer-events-none" />

          <div className="relative grid lg:grid-cols-12 gap-8 lg:items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
                Ready when you are
              </div>
              <h2 className="mt-4 text-[36px] lg:text-[60px] font-extrabold leading-[1.04] tracking-[-0.025em]">
                You've got 60 seconds.
                <br className="hidden sm:block" />
                We've got <span className="text-[#16d196]">£612m+ of proof.</span>
              </h2>
              <p className="mt-5 text-white/70 text-[16px] lg:text-[17px] max-w-2xl leading-relaxed">
                Start your free, no-obligation match now. If we can't find you a strong
                fit, we'll tell you straight. If we can, we'll send your due-diligence
                pack within 24 hours.
              </p>
            </div>

            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Link to="/apply" className="flex-1">
                <button className="w-full inline-flex items-center justify-center gap-1.5 bg-[#16d196] hover:bg-[#13b884] text-[#0d1a2e] rounded-full h-14 px-7 text-[15px] font-bold transition-colors shadow-[0_8px_24px_rgba(22,209,150,0.3)]">
                  Get matched in 60s
                  <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
                </button>
              </Link>
              <Link to="/#contact" className="flex-1">
                <button className="w-full inline-flex items-center justify-center gap-1.5 bg-transparent border border-white/20 hover:border-white/40 text-white rounded-full h-14 px-7 text-[15px] font-semibold transition-colors">
                  Speak to our team
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
